import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Alert, Form, Button } from 'react-bootstrap';
import { Accounts } from 'meteor/accounts-base';

import { getRedirectPath } from '../../../modules/checkDeployEnv';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import PageHeader from '../../atoms/PageHeader';
import Validation from '../../containers/Validation';

class ResetPassword extends Component {
  handleSubmit = form => {
    const { match } = this.props;
    const { token } = match.params;

    Accounts.resetPassword(token, form.newPassword.value, error => {
      if (error) {
        handleErrorInClient(error);
      } else {
        const { history, deployEnv } = this.props;
        history.push(getRedirectPath(deployEnv));
      }
    });
  };

  render() {
    const validationProps = {
      rules: {
        newPassword: {
          required: true,
          minlength: 6
        },
        repeatNewPassword: {
          required: true,
          minlength: 6,
          equalTo: '[name="newPassword"]'
        }
      },
      messages: {
        newPassword: {
          required: 'Enter a new password, please.',
          minlength: 'Use at least six characters, please.'
        },
        repeatNewPassword: {
          required: 'Repeat your new password, please.',
          equalTo: "Hmm, your passwords don't match. Try again?"
        }
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };
    return (
      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6}>
          <PageHeader>
            <h4>Reset Password</h4>
          </PageHeader>
          <Alert variant="info">
            To reset your password, enter a new one below. You will be logged in with your new
            password.
          </Alert>
          <Validation {...validationProps}>
            <Form onSubmit={event => event.preventDefault()}>
              <Form.Group>
                <Form.Label>New Password</Form.Label>
                <Form.Control type="password" name="newPassword" placeholder="New Password" />
              </Form.Group>
              <Form.Group>
                <Form.Label>Repeat New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="repeatNewPassword"
                  placeholder="Repeat New Password"
                />
              </Form.Group>
              <Button type="submit" variant="success">
                Reset Password &amp; Login
              </Button>
            </Form>
          </Validation>
        </Col>
      </Row>
    );
  }
}

ResetPassword.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired
};

export default ResetPassword;
